module.exports = __webpack_public_path__ + "img/prestige+.af55ff25.png";